<template>
  <div class="wrapper">
    <div v-if="hideAll">
      <div class="my-3  mx-2 pt-3"></div>
    </div>
    <action-bar v-else :schema="schema" />
    <div class="row schema-editor mx-2">
      <div class="col-3 toolbox"
           v-if="!hideAll">
        <toolbox
          style="height: calc(100vh - 200px); overflow-y: auto;"
          :schema="schema"
          :tableauData="ficheTableauData()"
        />
      </div>
      <div ref="canvasContainer" class="col-9 px-0 draw-zone">
        <loading v-if="this.loading()" />
        <div
          style="height: calc(100vh - 200px);"
          v-else-if="!this.loading() && !this.listSchema().length && !hideAll"
          class="d-flex align-content-stretch flex-wrap"
        >
          <b-jumbotron class="d-flex flex-column align-items-center justify-content-center flex-fill mb-0 align-center empty-schema">
            <template v-slot:header>Arystote</template>

            <p style="font-family: 'Open sans'">
             Vous n'avez pas encore de schéma, créez votre premier schéma.
            </p>

            <hr class="my-2">
            <b-button
              v-if="!isLoadingSchema()"
              variant="outline-primary"
              @click="() => this.handleAddSchema(true)"
            >
              <font-awesome-icon :icon="['fas', 'plus']" />
              Schéma
            </b-button>
            <b-button v-else variant="primary">
              <b-spinner small type="grow"></b-spinner> En attente...
            </b-button>
          </b-jumbotron>
        </div>
        <schema-canvas v-else-if="!this.loading() && this.listSchema().length && ficheTableauData()"
          style="height: calc(100vh - 200px); overflow-y: auto;"
          :schema="schema"
          :schema-data="schemaData"
          :tableau-data="ficheTableauData()"
          @export="handleExport"
        />
      </div>
    </div>
    <div class="fixed-bottom">
      <list-onglet
        :schemaDetails="listSchema()"
        :hideAll="hideAll"
        @addSchema="handleAddSchema"
        @renameSchema="handleRenameSchema"
        @tabChange="handleTabChange"
        @deleteSchema="handleDeleteSchema"
      />
    </div>
    <image-editor
      id="schema-export"
      ref="schemaExport"
    />
  </div>
</template>

<script>
import listOnglet from '../../components/schemaFonctionnel/listOnglet'
import { mapActions, mapGetters } from 'vuex'
import schemaCanvas from '../../components/schemaFonctionnel/schemaCanvas'
import toolbox from '../../components/schemaFonctionnel/toolbox'
import actionBar from '../../components/schemaFonctionnel/actionBar'
import loading from '../../components/loading'
import Schema from './model/schema'
import imageEditor from '../../components/utils/imageEditor'
import { EventBus, events } from '../../eventBus'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'

export default {
  components: {
    listOnglet,
    schemaCanvas,
    toolbox,
    actionBar,
    loading,
    imageEditor
  },
  data () {
    return {
      schemaData: null,
      schema: new Schema(),
      hideAll: false,
      data: null
    }
  },
  computed: {
    ...mapGetters(['currentSchema', 'notifLink'])
  },
  watch: {
    async currentSchema (val) {
      if (val) {
        this.setEntityId(parseInt(val))
        this.setLoading(true)
        this.schemaData = await this.getSchemaData(val)
        this.schema = new Schema()
        this.setLoading(false)
      }
    },
    notifLink (val) {
      if (this.currentSchema !== val.entite && val.entite != null) {
        this.setCurrentSchema(val.entite)
        this.setLinkComment(null)
      }
      this.setIsFromNotif(true)
    }
  },
  async created () {
    const idProject = this.$route.params.idProject
    this.setTypeModule('schema_fonctionnel')
    this.setLoading(true)
    if (!this.currentProject()) {
      this.setCurrentProject(idProject)
    }

    if (typeof this.$route.params.idInvitation !== 'undefined') {
      // const res = await axios({ url: ENTRYPOINT + '/invite/schema-fonctionnel/liste/' + idProject + '?invitation=' + this.$route.params.idInvitation, method: 'GET' })
      // await Promise.all([res.data.data, this.getFicheTableauData(idProject)])

      const payload = {
        idProject: idProject,
        idInvitation: this.$route.params.idInvitation
      }
      await Promise.all([this.listAllInvitedSchema(payload), this.getFicheTableauData(idProject)])
    } else {
      await Promise.all([this.listAllSchema(idProject), this.getFicheTableauData(idProject)])
    }
    await this.getFicheTableauData(idProject)
    if (this.notifLink) {
      this.setCurrentSchema(this.notifLink.entite)
      this.setIsFromNotif(true)
      this.setLinkComment(null)
    } else if (this.listSchema().length) {
      this.setCurrentSchema(this.listSchema()[0].id)
    } else {
      this.setLoading(false)
    }

    if (typeof this.$route.params.idInvitation !== 'undefined') {
      if (this.currentSchema !== null) {
        const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/details/' + this.currentSchema + '?invitation=' + this.$route.params.idInvitation, method: 'GET' })

        if (typeof res.data.data.isEditable !== 'undefined' && typeof res.data.data.isViewable !== 'undefined' &&
                (res.data.data.isEditable !== null || res.data.data.isViewable !== null)) {
          if (res.data.data.isEditable) {
            this.hideAll = false
          } else {
            this.hideAll = true
          }
        }
      } else {
        this.hideAll = true
      }
    } else {
      this.hideAll = false
    }
  },
  beforeDestroy () {
    this.setCurrentSchema(null)
  },
  methods: {
    ...mapActions(['setIsFromNotif', 'setLinkComment', 'setEntityId', 'setTypeModule', 'listAllSchema', 'listAllInvitedSchema', 'addNewSchema', 'setProjectId', 'renameSchema', 'deleteSchema', 'setCurrentProject', 'setCurrentSchema', 'getSchemaData', 'setLoading', 'getFicheTableauData']),
    ...mapGetters(['isLoadingSchema', 'isCreatingSchema', 'listSchema', 'currentProject', 'loading', 'ficheTableauData']),
    async handleAddSchema (shouldLoad = false) {
      const newSchema = {
        nom: 'Schéma ' + parseInt(this.listSchema().length + 1),
        rang: this.listSchema().length + 1,
        projet: parseInt(this.currentProject(), 10),
        data: null
      }
      await this.addNewSchema(newSchema)
      if (shouldLoad) {
        this.setCurrentSchema(this.listSchema()[0].id)
      }
    },
    async handleRenameSchema (data) {
      this.renameSchema(data)
    },
    async handleTabChange (id) {
      if (typeof this.$route.params.idInvitation !== 'undefined') {
        const res = await axios({ url: ENTRYPOINT + '/api/schema-fonctionnel/details/' + id + '?invitation=' + this.$route.params.idInvitation, method: 'GET' })

        if (typeof res.data.data.isEditable !== 'undefined' && typeof res.data.data.isViewable !== 'undefined' &&
                (res.data.data.isEditable !== null || res.data.data.isViewable !== null)) {
          if (res.data.data.isEditable) {
            this.hideAll = false
          } else {
            this.hideAll = true
          }
        }
      } else {
        this.hideAll = false
      }

      this.setCurrentSchema(id)
      this.setEntityId(parseInt(id))
      EventBus.$emit(events.REFRESH_NOTIFICATION)
    },
    handleDeleteSchema (id) {
      this.deleteSchema(id)
    },
    handleExport (file) {
      console.log('file', file)
      this.$refs.schemaExport.open(file)
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrapper{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 100px);
    .flex-fill{
      flex: 1;
    }
    .schema-editor{
      flex: 0 1 auto;
      height: 100%;
    }

    .draw-zone{
      // border: 1px solid rgba($color: #000000, $alpha: 0.15);
      // box-shadow: 1px 3px 4px 1px rgba(173,173,173,0.5);
      height: -webkit-fill-available;
      height: -moz-available;
  }

  .draw-zone {
    // border: 1px solid rgba($color: #000000, $alpha: 0.15);
    // box-shadow: 1px 3px 4px 1px rgba(173, 173, 173, 0.5);
    height: -webkit-fill-available;
    height: -moz-available;
    height: fill-available;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageSchemaFonctionnel/index.vue